import { render, staticRenderFns } from "./GroovyScript.vue?vue&type=template&id=908eec7c&scoped=true&"
import script from "./GroovyScript.vue?vue&type=script&lang=js&"
export * from "./GroovyScript.vue?vue&type=script&lang=js&"
import style0 from "./GroovyScript.vue?vue&type=style&index=0&id=908eec7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908eec7c",
  null
  
)

export default component.exports